import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
import Scrollspy from 'react-scrollspy';
import Slider from '../components/Slider';
const UrbanMushroomVisit = () => {
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro " >
        <h1> Urban Mushroom Visit</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Contribution
            </div>
              <Scrollspy
              className="scrollspy" items={['Background', 'Story', 'Visit', 'Translated']}
                currentClassName="active">
              <li><a href="#Background">Background about the farmer(Russell)</a></li>
              <li><a href="#Story">Story about mushrooms</a></li>
              <li><a href="#Visit">Visit to Urban Mushroom</a></li>
              <li><a href="#Translated">Translated script</a></li>
              </Scrollspy>
              
          </div>

        </div>
        <div className="main_lab_style">
          <>
            <p id="Background">
              <h1>
                Background about the farmer (Russell):
                <br />
                &nbsp;
              </h1>
              Russell is the founder of Urban Mushroom and operates the farm by himself. He studied BSc in engineering in CUHK, MSc in Sustainable Agriculture in the UK (NCL), and gained insights on developing sustainable agriculture in Hong Kong. Then he started cultivating mushrooms as he found that mushrooms need relatively less light to grow which suits his home environment of having an old pig yard.He utilizes used coffee beans to grow mushrooms. Russell is currently growing 4 types of mushrooms, which are Pink Oyster Mushroom, Golden Oyster Mushroom, Phoenix mushroom, and Common Oyster Mushroom.

            </p>
            
            <section id="Story">

            
            <p>
                <h1>Story about mushrooms: </h1>
            </p>
            <p>
                Mushrooms are known as fungi which contain <em>Aspergillus Oryzae</em> which can be genetically modified by CRISPR-Cas9 method to produce novel anticancer compounds.

            </p>
            
            <p>&nbsp;</p>
            </section>

            <section id="Visit">


              <p>
                <h1>Visit to Urban Mushroom: </h1>
              </p>
              <p>
                Our team SeCure visited Urban Mushroom Farm <b>on 21st August</b> and met Russell (the founder of Urban Mushroom) to learn more about the process of sustainably cultivating fungi on a larger scale than a lab and ask him about the opinions of our project. He thought our project helps raise public awareness about mushrooms due to their potential anticancer property, which in turn benefits other local farmers. However, the issue of genetically modified technology raises ethical concerns, thus it is important for us to prove that genetically modified fungi are safe to be applied in daily life.
                <br />
                <br />
                <br />

                
                <iframe title="CityU_HongKong: A day at Urban Mushroom (2022) [English]" width="100%" height="415" src="https://video.igem.org/videos/embed/c84fc4ce-e214-491e-9859-5eccf52b43b9" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>

              </p>

              <p>&nbsp;</p>
            </section>
            
            
            
          </>
        </div>
      </section>
      <section id="Translated">
        <h1>
          Translated script

        </h1>
        <h4>
          <strong>
          Part 1: General Questions <br />
          Process of operating Urban Mushroom Farm
          </strong>
        </h4>

        <div id="chat">
          <div>
            <img style={{ marginBottom: 30 }} src="https://static.igem.wiki/teams/4154/wiki/assets/chat1.svg" alt="" />
          </div>
          <br />
          <br />
          <h1>
            Why cultivate mushrooms?
          </h1>
          <br />
          <br />

          <div>
            <img style={{ marginBottom: 30 }} src="https://static.igem.wiki/teams/4154/wiki/assets/chat2.svg" alt="" />
          </div>
          <br />
          <br />
          <h1>
            Why sustainable farming?
          </h1>
          <br />
          <br />
          <div>
            <img style={{ marginBottom: 30 }} src="https://static.igem.wiki/teams/4154/wiki/assets/chat3-1.svg" alt="" />
          </div>

          <br />
          <br />
          <h1>
            How to make mushroom farms sustainable?
          </h1>
          <br />
          <br />

          <div>
            <img style={{ marginBottom: 30 }} src="https://static.igem.wiki/teams/4154/wiki/assets/chat4-1.svg" alt="" />
          </div>

          <br />
          <br />
          <h1>
            How mushrooms play a role on reducing environmental waste

          </h1>
          <br />
          <br />

          <div>
            <img style={{ marginBottom: 30 }} src="https://static.igem.wiki/teams/4154/wiki/assets/chat5.svg" alt="" />
          </div>

          <br />
          <br />
          <h1>
            Part 2: Specific Questions related to iGEM SeCure
            <br />
            


          </h1>
          <h4>
            1. Opinions on our iGEM project
          </h4>
          <br />
          <br />

          <div>
            <img style={{ marginBottom: 30 }} src="https://static.igem.wiki/teams/4154/wiki/assets/chat6.svg" alt="" />
          </div>


          <br />
          <br />
          <h4>
            2.How iGEM project may benefit other local farmers



          </h4>
          <br />
          <br />

          <div>
            <img style={{ marginBottom: 30 }} src="https://static.igem.wiki/teams/4154/wiki/assets/chat7.svg" alt="" />
          </div>

          <br />
          <br />
          <h4>
            3. How to Increase yield
            of anti-cancer compounds

          </h4>
          <br />
          <br />

          <div>
            <img style={{ marginBottom: 30 }} src="https://static.igem.wiki/teams/4154/wiki/assets/chat8.svg" alt="" />
          </div>
          <br />
          <br />
          <h1>  
          Part 3: Ending
          </h1>
          <br />
          <br />

          <div>
            <img style={{ marginBottom: 30 }} src="https://static.igem.wiki/teams/4154/wiki/assets/chat9.svg" alt="" />
          </div>


          <br />
          <br />
          <h1>
            Pictures
          </h1>
          <br />
          <br />
          <div style={{width:'70%'}}>
            <Slider images={["https://static.igem.wiki/teams/4154/wiki/assets/img-1011-2.png", "https://static.igem.wiki/teams/4154/wiki/assets/img-09262.png"]} />

          </div>

          

        </div>
      </section>
    </div>
  );
}

export default UrbanMushroomVisit;
